<template>
    <div v-if="questions[current_question]" class="question-wrap">
        <v-layout justify-space-between align-center mb-4
                  :class="{'px-3': $vuetify.breakpoint.smAndDown}"
        >
            <v-flex class="xs7 sm8 display-1 font-weight-bold">{{ $t("Проверочное тестирование") }}</v-flex>
        </v-layout>
        <v-layout row wrap>
            <div v-for="(question, i) in questions"
                 :id="i"
                 :key="i"
                 class="question-num"
                 :class="{
                     'active': i == current_question,
                     // 'correct': resultsLayout && if_correct(i-1),
                     // 'wrong': resultsLayout && !if_correct(i-1)
                 }"
            >
                {{ i + 1 }}
            </div>
        </v-layout>
        <div class="question-block pa-4 mt-4">
            <div class="headline mb-4 font-weight-bold">
                {{ $t("Вопрос {questionNumber} из {questionsCount}", {questionNumber: current_question+1, questionsCount: questions.length}) }}
            </div>
            <div class="question-text mb-4" v-html="questions[current_question].question"></div>
            <v-layout column mb-5>
                <v-flex mb-3>
                    <v-radio-group ref="radioGroup" :value="answerModel">
                        <v-radio
                            v-for="(answer, index) in questions[current_question].answers"
                            :key="index"
                            :value="answer"
                            @change="selectAnswerHandle(questions[current_question].questionId, answer)"
                        >
                            <template #label>
                                {{ answer }}
                            </template>
                        </v-radio>
                    </v-radio-group>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-space-between>
                <button_bd_white
                    v-if="current_question !== 0"
                    :class="{'flex xs12 order-xs2 mb-4': $vuetify.breakpoint.xs}"
                    @click.native="previousQuestionHandle(current_question - 1)"
                >
                    {{ $t('Предыдущий вопрос') }}
                </button_bd_white>
                <button_red
                    :class="{'flex xs12 mb-2': $vuetify.breakpoint.xs}"
                    @click.native="nextQuestionHandle(current_question + 1)"
                >
                    {{ current_question === questions.length - 1 ? $t("Завершить тестирование") : $t("Следующий вопрос") }}
                </button_red>
            </v-layout>
        </div>
    </div>
</template>

<script>
import {mapMutations, mapGetters, mapActions} from 'vuex';
import {button_red, button_bd_white} from '@/components/ui/buttons/base_buttons';
import {validationMixin} from 'vuelidate';
import {required} from 'vuelidate/lib/validators';

export default {
  name       : 'KnowledgeCheckQuestions',
  components : {button_bd_white, button_red},
  mixins     : [validationMixin],
  validations: {
    answerModel: {
      required,
    },
  },
  props: {
    current_question: {
      type: Number,
    },
    questions: {
      type   : Array,
      default: () => [],
    },
  },
  data() {
    return {
      answerModel: null,
    };
  },
  computed: {
    ...mapGetters('knowledge_check/knowledge_check_test', ['get_answers']),
    ...mapGetters('course_info/modals', [
      'modal_success',
      'modal_failed',
      'modal_test',
      'modal_test_cancel',
    ]),
  },
  watch: {
    current_question() {
      this.$nextTick(() => {
        if (this.questions[this.current_question]) {
          this.answerModel = this.get_answers[this.questions[this.current_question].questionId];
        }
      });
    },
  },

  mounted() {
    if (this.questions[this.current_question]) {
      this.answerModel = this.get_answers[this.questions[this.current_question].questionId];
    }
    this.SET_CURRENT_QUESTION(0);
  },
  methods: {
    ...mapActions('knowledge_check/knowledge_check_test', ['check_answer']),
    ...mapActions('course_info/steps', [
      'next_step',
    ]),
    ...mapMutations('knowledge_check/knowledge_check_test', ['SET_CURRENT_QUESTION', 'SET_QUESTION_ANSWER']),
    nextQuestionHandle(questionIndex) {
      this.$v.$touch();
      this.next_step();
      if (this.$v.$invalid) {
        return;
      }
      if (questionIndex !== this.questions.length) {
        this.SET_CURRENT_QUESTION(questionIndex);
      } else if (questionIndex === this.questions.length) {
        this.check_answer();
      }
    },
    previousQuestionHandle(questionIndex) {
      if (questionIndex !== -1) {
        this.SET_CURRENT_QUESTION(questionIndex);
      }
    },
    selectAnswerHandle(questionId, answer) {
      this.SET_QUESTION_ANSWER({questionId, answer});
      this.answerModel = answer;
    },
  },
};
</script>
